module.exports = __webpack_public_path__ + "static/img/icon-uncollect.96cb5699.svg";